module.exports = __webpack_public_path__ + "static/far-cry_contest-9fbe47df420b40b6b3f8df5aaaa71390.jpg";